import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import 'react-quill/dist/quill.snow.css';

// import App from "./App";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "./index.scss";
import { LogoProvider } from "context/LogoContext";
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LogoProvider>
        <App />
      </LogoProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
